import offlineImage from "@/assets/offline.webp?inline";

export type StatusPageVariant =
  | "400"
  | "401"
  | "403"
  | "404"
  | "500"
  | "503"
  | "offline"
  | "comingSoon";

export type StatusPageContent = {
  image: string;
  title: string;
  description: string;
};

// The offline illustration is inlined into the bundle: when the network is gone
// a file from /public could not be fetched to show it.
export const STATUS_PAGES: Record<StatusPageVariant, StatusPageContent> = {
  "400": {
    image: "/images/errors/400.webp",
    title: "درخواست نامعتبر بود",
    description: "اطلاعاتی که فرستاده شد برای ما قابل فهم نبود. یک بار دیگر امتحان کنید.",
  },
  "401": {
    image: "/images/errors/401.webp",
    title: "اول وارد حساب‌تان شوید",
    description: "برای دیدن این صفحه باید وارد پنل سفانو شوید.",
  },
  "403": {
    image: "/images/errors/403.webp",
    title: "دسترسی به این بخش ندارید",
    description:
      "این بخش فقط برای نقش‌های مشخصی باز است. اگر فکر می‌کنید اشتباهی رخ داده، با مدیر فروشگاه تماس بگیرید.",
  },
  "404": {
    image: "/images/errors/404.webp",
    title: "این صفحه پیدا نشد",
    description: "آدرسی که دنبالش هستید وجود ندارد یا جابه‌جا شده است.",
  },
  "500": {
    image: "/images/errors/500.webp",
    title: "مشکلی پیش آمد",
    description: "یک خطای غیرمنتظره رخ داد. تیم ما در جریان است؛ کمی بعد دوباره امتحان کنید.",
  },
  "503": {
    image: "/images/errors/503.webp",
    title: "زود برمی‌گردیم",
    description: "سرویس سفانو در حال به‌روزرسانی است و تا چند دقیقه دیگر در دسترس خواهد بود.",
  },
  offline: {
    image: offlineImage,
    title: "اتصال اینترنت قطع است",
    description: "به نظر می‌رسد آفلاین هستید. به محض برقراری اتصال، صفحه خودش ادامه می‌دهد.",
  },
  comingSoon: {
    image: "/images/coming-soon.webp",
    title: "به‌زودی",
    description: "در حال آماده‌سازی این بخش هستیم. خیلی زود اینجا چیزهای جدیدی می‌بینید.",
  },
};

/** Picks the page that best explains a route-level failure. */
export function getStatusPageVariant(
  status: number | null,
  isNetworkError: boolean,
): StatusPageVariant {
  if (isNetworkError)
    return typeof navigator !== "undefined" && !navigator.onLine ? "offline" : "503";
  if (status === 400 || status === 422) return "400";
  if (status === 401) return "401";
  if (status === 403) return "403";
  if (status === 404) return "404";
  if (status === 502 || status === 503 || status === 504) return "503";
  return "500";
}
